import http from './http';
//发送验证码
export function getVerifyCode(params, config = {}) {
  return http.get('/riskcontrol/feign/auth/send/code', { params, ...config });
}
// 校验验证码
export function checkVerifyCode(params, config = {}) {
  return http.post('/riskcontrol/feign/auth/check/code', params, { ...config });
}
// 修改密码
export function setChangePassword(params, config = {}) {
  return http.post('/riskcontrol/feign/auth/update/pwd', params, { ...config });
}
